import { collection, query, getDocs, doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "@/firebase";
import User from "@/models/user";

export function formatDate(epoch) {
    const date = new Date(epoch);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${date.getFullYear()} ${date
        .getHours()
        .toString()
        .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
}

export async function transferLogsToSummaries() {
    try {
        const logsCollectionRef = collection(db, "Logs");
        const logsSnapshot = await getDocs(logsCollectionRef);
        const logsByMonth = {};

        // Regrouper les logs par mois et année
        logsSnapshot.forEach((doc) => {
        const log = doc.data();
        const createdAt = new Date(log.createdAt);

        // Obtenir le mois et l'année
        const month = String(createdAt.getMonth() + 1).padStart(2, "0"); // Les mois commencent à 0
        const year = createdAt.getFullYear();

        // Générer la clé pour regrouper les logs
        const summaryKey = `LogSummary_${month}_${year}`;

        // Ajouter le log au tableau correspondant
        if (!logsByMonth[summaryKey]) {
            logsByMonth[summaryKey] = [];
        }
        logsByMonth[summaryKey].push({ id: doc.id, ...log });
        });

        // Sauvegarder chaque groupe de logs dans Firestore
        for (const [summaryKey, logs] of Object.entries(logsByMonth)) {
        const summaryDocRef = doc(db, "LogSummaries", summaryKey);

        // Sauvegarder les logs dans un document
        await setDoc(summaryDocRef, { logs });
        console.log(`Logs sauvegardés dans le document ${summaryKey}`);
        }

    } catch (error) {
        console.error("Erreur lors du transfert des logs :", error);
    }
}

export async function getFoodInfoWithBarcode(barcode) {
    try {
        const response = await fetch(`https://world.openfoodfacts.org/api/v0/product/${barcode}.json`);
        
        if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 1) {
        return data.product; // Contient toutes les infos du produit
        } else {
        throw new Error(`Produit non trouvé pour le code-barres ${barcode}`);
        }

    } catch (error) {
        console.error("Erreur lors de la récupération du produit :", error);
        return null;
    }
}


/**
 * Récupère les données utilisateur à partir de son ID Firebase Auth.
 * @param {string} userId - UID de l'utilisateur Firebase Auth
 * @returns {Promise<User>} - Instance de la classe User remplie avec les données Firestore
 */
export async function fetchUserData(userId) {
  const userInstance = new User();

  if (!userId) return userInstance;

  try {
    const docRef = doc(db, "User", userId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      Object.assign(userInstance, data);console.log('USER DATA FROM FIREBASE:', JSON.stringify(data));
    } else {
      console.warn(`Aucun utilisateur trouvé pour l'ID ${userId}`);
    }
  } catch (error) {
    console.error("Erreur lors de la récupération des données utilisateur :", error);
  }

  return userInstance;
}

export function getRoleIcon(role){
    switch (role) {
    case 'Admin':
        return 'mdi-shield-account';
    case 'Operator':
        return 'mdi-account-tie';
    default:
        return 'mdi-badge-account-outline';
    }
}

export async function fetchUsers() {
    const userCollection = collection(db, 'User');
    const users = [];
    const querySnapshot = await getDocs(query(userCollection));

    querySnapshot.forEach((doc) => {
        const userData = doc.data();
        users.push({
            id: doc.id,
            userId: userData.userId,
            username: userData.userName,
        });
    });

    return users;
}
